import type { LatLngExpression } from "leaflet";

import type { Country } from "./company.js";
import type { Organization } from "./planting.js";

export type CleanedCompanyData = {
	countries: Country[];
	impacts: Impacts;
	trees: Count;
	treesByForestTypes: ForestType[];
};

export type CleanedPlantingData = CountryPlantingData[];

export type Count = {
	designated: number;
	ordered: number;
	planted: number;
};

export type CountryPlantingData = {
	id: number;
	lat: string;
	long: string;
	name: string;
	regions: RegionPlantingData[];
};

export type ForestType = Count & {
	id: number;
	name: string;
};

/** Represents a single impact category. */
export type Impact = {
	/** The count of the impact category. (ex. 1000) */
	count: number;
	/** The icon to display for the impact category. */
	icon: string | { src: string };
	/** The primary text to display for the impact category. (ex. "Trees Planted") */
	primary: string;
	/**
	 * The secondary text to display for the impact category. (ex. "Compares to
	 * 1000 trees in a forest")
	 */
	secondary: string;
	secondaryValue: string;
	/** The name of the impact category. */
	slug: string;
	/** The units of the impact category. (ex. "kg") */
	units?: string;
};

export type Impacts = Impact[];

export type RegionPlantingData = {
	id: number;
	lat: null | number;
	long: null | number;
	name: string;
	organization: Organization;
	subSites: SubSite[];
};

export type SubSite = {
	area: number;
	counts: Count;
	description: string;
	forestType: {
		id: number;
		name: string;
	};
	geofence?:
		| undefined
		| {
				coordinates: LatLngExpression[][][] | undefined;
				type: string;
		  };
	id: number;
	image: null | string;
	manager: {
		name: string;
		title: string;
	};
	name: string;
	numberOfPlanters: number;
	type: "Kelp" | "Trees";
};

export const impacts = {
	areaPlanted: "area_planted",
	co2: "co2",
	oceanAreaPlanted: "ocean_area_planted",
	workingDays: "working_days",
	yield: "yield",
} as const;
